import 'typeface-roboto';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.jsx';
import {Provider} from "react-redux";
import store from "./store/store.js";

const root = (
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>
);

ReactDOM.render(root, document.getElementById('root'));
